import { render } from "./TablaCreditos.vue?vue&type=template&id=50549700"
import script from "./TablaCreditos.vue?vue&type=script&lang=js"
export * from "./TablaCreditos.vue?vue&type=script&lang=js"

import "./TablaCreditos.vue?vue&type=style&index=0&id=50549700&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__